import ModalComponent from 'components/Common/Modal';
import normalize from 'components/Dashboard/utilities/normalizeString';

// ponytail: this is deliberately a separate popup from SendPopup's contactholmember@ warning.
// This one warns about contacts with no email address at all, at "Create email" time. SendPopup's
// warning fires later, on the compose page, for contacts sharing the generic
// contactholmember@parliament.uk address (which counts as "having an email"). The two populations
// don't overlap and the steps don't run at the same time, so there's nothing to merge.
// Continue stays open with a spinner while onContinue runs (isLoading) — the popup only closes via
// navigating away on success, or the X/Escape/overlay/Cancel, which is a real no-op cancel since
// nothing has been created yet at this point.

// Same profile-link rule as the "name" cell in CrmContactItem.jsx: a stakeholder-linked contact goes
// to their stakeholder page, a custom (manually-added) contact has no such page — link to editing it.
const contactProfileUrl = ({ id, title, contactId }) =>
  contactId ? `/stakeholders/${contactId}/${normalize(title)}` : `/people/directory/update/${id}`;

const NoEmailContactsPopup = ({ isOpen, setIsOpen, missingEmailCount, people, onContinue, isLoading }) => {
  const countLabel = `${missingEmailCount} ${missingEmailCount === 1 ? 'person' : 'people'}`;
  // "name<TAB>url" per line — the scrollable-list-tooltip's render function splits on both to turn
  // each line into a link opening in a new tab.
  const peopleTooltipContent = people?.map((person) => `${person.title}\t${contactProfileUrl(person)}`).join('\n');

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} maxWidth={450}>
      <div className='py-3 pt-4'>
        <h3 className='topic-title section-title pl-lg-5 pl-4 pb-3 mb-0'>{countLabel} won't be included</h3>
        <div className='popup-body px-3 px-lg-5 text-center mt-4'>
          <p>
            {people?.length > 0 ? (
              <span
                className='dotted-underline-hover'
                data-tooltip-id='scrollable-list-tooltip'
                data-tooltip-content={peopleTooltipContent}
              >
                {countLabel}
              </span>
            ) : (
              countLabel
            )}{' '}
            you've selected {missingEmailCount === 1 ? "doesn't" : "don't"} have an email address associated with them,
            and so won't be included in this campaign. You can add an email address to a stakeholder manually on their
            page.
          </p>
        </div>
        <div className='mt-4 d-flex justify-content-center pb-lg-2'>
          <button
            className='general-button px-4 py-2 main-subtle-text border rounded light-blue-background-004-hover'
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </button>
          <button
            className={`general-button main-button px-4 py-2 ml-4 ${isLoading ? '' : 'light-blue-background-08-hover'}`}
            onClick={onContinue}
            disabled={isLoading}
            style={{ backgroundColor: '#0094cc', border: 'none' }}
          >
            {isLoading ? <i className='fas fa-spinner fa-spin' style={{ marginRight: '2px' }}></i> : 'Continue'}
          </button>
        </div>
      </div>
    </ModalComponent>
  );
};

export default NoEmailContactsPopup;
